import {
  DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_BEGIN,
  DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_SUCCESS,
  DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_FAILURE,
  DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_DISMISS_ERROR,
} from './constants';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios'
export function createCollectionfromXano(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_BEGIN,
    });
    const { projectId, version, data } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xano/create-collection-xano`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Created Collection', {
            uuid: res.data.uuid,
            colletionName: res.data.colletionName,
          });
          toast.success('Collection Created Successfully !');
          console.log('collection stored done', res);
          resolve(res);
        },

        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          Mixpanel.track('Failed to creat collection');
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionfromXanoError() {
  return {
    type: DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_BEGIN:
      return {
        ...state,
        createCollectionfromXanoPending: true,
        createCollectionfromXanoError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_SUCCESS:
      return {
        ...state,
        createCollectionfromXanoPending: false,
        createCollectionfromXanoError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_FAILURE:
      return {
        ...state,
        createCollectionfromXanoPending: false,
        createCollectionfromXanoError: action.data.error,
      };

    case DATA_CONNECTOR_CREATE_COLLECTIONFROM_XANO_DISMISS_ERROR:
      return {
        ...state,
        createCollectionfromXanoError: null,
      };

    default:
      return state;
  }
}
